<template>
    <b-card>
      <template slot="header">
        <b-button @click="$router.go(-1)" class="breadcrumb-back-btn" size="sm" variant="link"><i
          class="fa fa-chevron-left fa-fw" aria-hidden="true"></i></b-button>
        {{$t('DETAIL_APPLICANT')}}
      </template>
    <basic-view-form></basic-view-form>
    </b-card>
</template>

<script>
  import BasicViewForm from '@/components/applicant/basic/BasicViewForm'
    export default {
        name: "View",
        components:{
          BasicViewForm
        },
    }
</script>

<style scoped>

</style>
